import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GenericUpdate } from '../redux/actions';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
interface NavigationUtilPropTypes {

}

const NavigationUtil  = (props : NavigationUtilPropTypes) => {
    const navigate = useNavigate();
    const force_redirect = useAppSelector(state => state.force_redirect)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (force_redirect) {
            navigate(force_redirect);
            dispatch(GenericUpdate({ field: 'force_redirect', type: 'reset' }))
        }
    }, [force_redirect])
    
    return (<></>);
}


interface RedirectPropTypes {
    to: string
}

const Redirect = ({to} : RedirectPropTypes) => {
    const navigate = useNavigate()

    useEffect(()=>{
        navigate(to);
    }, [])
    
    return (<></>);
}

export { NavigationUtil, Redirect }

